import React, { useState } from "react";
import PropTypes from "prop-types";
import MenuIcon from "@mui/icons-material/Menu";
import { HeaderIconContainer } from "../Header.styled";
import { Drawer } from "@mui/material";
import { headerNavigationConstants } from "constants/navigationConstants";
import HeaderNavigationItem from "../HeaderNavigation/HeaderNavigationItem/HeaderNavigationItem";
import { DrawerMenu } from "./HeaderDrawer.styled";
import DropdownNavigationItem from "../HeaderDropdownNavigationItem/HeaderDropdownNavigationItem";
// In progress
const HeaderDrawer = () => {
  const [isOpened, setIsOpened] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const onClick = () => {
    setIsOpened(false);
    setOpenDropdownIndex(null);
  };

  const handleDropdownToggle = (index, state) => {
    setOpenDropdownIndex(state ? index : null);
  };

  return (
    <>
      <HeaderIconContainer
        onClick={() => setIsOpened((prevState) => !prevState)}
      >
        <MenuIcon />
      </HeaderIconContainer>
      <Drawer
        anchor="top"
        sx={{ pt: 5 }}
        open={isOpened}
        onOpen={() => setIsOpened(true)}
        onClose={() => setIsOpened(false)}
      >
        <DrawerMenu>
          {headerNavigationConstants.map?.((singleNavigationItem, index) => {
            if (singleNavigationItem.dropdown) {
              return (
                <DropdownNavigationItem
                  key={index}
                  routes={[
                    { title: singleNavigationItem.title },
                    ...singleNavigationItem.dropdown,
                  ]}
                  onClick={onClick}
                  onToggle={(state) => handleDropdownToggle(index, state)}
                  isOpen={openDropdownIndex === index}
                />
              );
            }

            return (
              <HeaderNavigationItem
                key={index}
                route={singleNavigationItem}
                onClick={onClick}
              />
            );
          })}
        </DrawerMenu>
      </Drawer>
    </>
  );
};

HeaderDrawer.propTypes = {
  children: PropTypes.node,
  offsetRef: PropTypes.object,
};

export default HeaderDrawer;
